import { render, staticRenderFns } from "./viewCandidateResume.vue?vue&type=template&id=cab4feb2"
import script from "./viewCandidateResume.vue?vue&type=script&lang=js"
export * from "./viewCandidateResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports